<aside class="home-aside" style="min-width:14rem;padding:0 var(--wa-spacing-large) var(--wa-spacing-large) var(--wa-spacing-large);position:sticky;top:var(--wa-spacing-large);">
	<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>On this page</div>
	<ul style="display:flex;flex-direction:column;gap:var(--wa-spacing-x-small);list-style:none;margin:var(--wa-spacing-small) 0 0 0;padding:0;">
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('about-intro').scrollIntoView({behavior:'smooth'})">Overview</a>
		</li>
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('annotation-driven').scrollIntoView({behavior:'smooth'})">Annotation-Driven</a>
		</li>
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('reactive-stack').scrollIntoView({behavior:'smooth'})">Reactive Stack</a>
		</li>
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('real-time-overview').scrollIntoView({behavior:'smooth'})">Real-Time</a>
		</li>
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('developer-experience').scrollIntoView({behavior:'smooth'})">Developer Experience</a>
		</li>
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('production-ready').scrollIntoView({behavior:'smooth'})">Production Ready</a>
		</li>
	</ul>
</aside>